/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Carrières',
    titleMeta: 'Carrières — Offres d’emploi | CamDiab',
    descriptionMeta: 'Découvrez les opportunités de carrière chez CamDiab. Rejoignez nos équipes au service des personnes vivant avec le diabète.',
    keywords: 'CamDiab carrières, emplois, offres, diabète',
    localeMeta: 'fr_ch',

    bannerTitle: 'Offres d’emploi',
    bannerSubtitle: 'Vous souhaitez rejoindre notre équipe ?',
    heroNote: 'Toutes les offres sont publiées en anglais.',

    introBody:
        'Vous cherchez un nouveau défi et souhaitez contribuer à un changement significatif ? Nous serions ravis d’échanger avec vous. Nous investissons dans nos collaborateurs, le cœur du groupe CamDiab. Nos avantages sociaux visent à révéler le meilleur de chacun, notamment :',

    benefitsTitle: '',
    benefits: [
        'Participation employeur généreuse à la retraite',
        'Assurance médicale privée',
        'Assurance vie',
        'Prime annuelle discrétionnaire',
        '29 jours de congés annuels plus 8 jours fériés',
        'Possibilité de travailler sur une technologie innovante susceptible de transformer la prise en charge du diabète et d’améliorer les résultats pour les patients',
        'Environnement de travail collaboratif et dynamique',
        'Rémunération et avantages compétitifs, avec possibilités de formation et d’évolution',
    ],

    outroHtml:
        'Si vous souhaitez avoir un impact concret, nous serions ravis d’échanger avec vous :<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'Aucun poste pour le moment',
    emptyVacancyBody:
        'Nous ne recrutons peut-être pas pour l’instant, mais CamDiab se développe, et nous sommes toujours intéressés par les personnes passionnées par l’amélioration de la vie des personnes vivant avec le diabète. Revenez consulter cette page.',

    applyLabel: 'Postuler',
};
